import { ContextualDate } from "@/api";
import * as Time from "@/utils/time";
import { DateField } from "turboui";

/**
 * Takes a ContextualDate object and returns a DateField.ContextualDate object that can be used in the UI.
 *
 * @param {ContextualDate | null | undefined} obj The ContextualDate object to parse.
 * @returns {DateField.ContextualDate | null} The parsed contextual date, or null if the input or its date is missing.
 */
export function parseContextualDate(obj: ContextualDate | undefined | null): DateField.ContextualDate | null {
  if (!obj) return null;

  // Contextual dates are calendar dates, not UTC timestamps.
  const date = Time.parseDate(obj.date);
  if (!date) return null;

  return {
    date,
    dateType: obj.dateType,
    value: obj.value,
  };
}

/**
 * Takes a DateField.ContextualDate object and returns a ContextualDate object that can be sent to the server.
 *
 * @param {DateField.ContextualDate | null | undefined} obj The DateField.ContextualDate object to serialize.
 * @returns {ContextualDate | null} The ContextualDate object that was serialized, or null if the input was null or undefined.
 */
export function serializeContextualDate(obj: DateField.ContextualDate | undefined | null): ContextualDate | null {
  if (!obj) return null;

  return {
    __typename: "contextual_date",
    date: Time.toDateWithoutTime(obj.date),
    dateType: obj.dateType,
    value: obj.value,
  };
}
